import React from 'react';
import { MaterialSelectorLabelProps } from '../interfaces';

const MaterialSelectorLabel: React.FC<MaterialSelectorLabelProps> = ({
  selectedMaterial,
  visible,
}) => {
  if (!visible) return null;

  return (
    <label className="input-label block">
      Material: <span className="font-medium">{selectedMaterial}</span>
    </label>
  );
};

export default MaterialSelectorLabel;
